(function(){
  function metal(c){
    var svg='<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48">'
      +'<defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1">'
      +'<stop offset="0" stop-color="'+c[0]+'"/><stop offset="0.27" stop-color="'+c[1]+'"/>'
      +'<stop offset="0.5" stop-color="'+c[2]+'"/><stop offset="0.74" stop-color="'+c[3]+'"/>'
      +'<stop offset="1" stop-color="'+c[4]+'"/></linearGradient></defs>'
      +'<rect width="48" height="48" fill="url(#g)"/>'
      +'<polygon points="0,28 20,48 32,48 0,16" fill="#ffffff" opacity="0.15"/>'
      +'<polygon points="36,0 48,0 48,12" fill="#ffffff" opacity="0.10"/>'
      +'</svg>';
    return 'url("data:image/svg+xml,'+encodeURIComponent(svg)+'") center/cover no-repeat';
  }
  var SW={
    gold:metal(['#fdf1c4','#edcd6b','#cfa83e','#ba8a2c','#a3741f']),
    silver:metal(['#fdfdfd','#e4e4e4','#c6c6c6','#a8a8a8','#909090']),
    rose:metal(['#fae0d4','#edb7a7','#d99280','#c37b69','#ad6654']),
    pearl:metal(['#fffffd','#f3efe7','#e7e0d4','#d9d1c2','#c9bdaa']),
    turq:metal(['#9eeee3','#5fccbf','#36 afa1'.replace(' ',''),'#23938 6'.replace(' ',''),'#1a7d72'])
  };
  function bg(v){
    var s=(v||'').toLowerCase();
    if(/ros[eé]|rosa|rosado|rose ?gold|oro rosa|róż|roz/.test(s))return SW.rose;
    if(/white ?gold|weiss ?gold|weiß ?gold|bia[łl]e? ?z[łl]ot|oro blanco|or blanc/.test(s))return SW.silver;
    if(/oro|gold|goud|dorad|golden|\bor\b|złot|zlot/.test(s))return SW.gold;
    if(/plata|silver|plateado|zilver|argent|silber|silv|srebr/.test(s))return SW.silver;
    if(/perla|pearl|nacar|nácar|perł|krem|cream/.test(s))return SW.pearl;
    if(/turques|turquoise|türkis|turkus/.test(s))return SW.turq;
    if(/negro|black|zwart|noir|nero|czarn/.test(s))return 'linear-gradient(135deg,#3a3a3a,#171717)';
    if(/blanco|white|wit|weiss|weiß|bianc|bia[łl]/.test(s))return 'linear-gradient(135deg,#ffffff,#ededed)';
    if(/azul|blue|blau|bleu|niebiesk|b[łl][eę]kit|blekit|granat/.test(s))return 'linear-gradient(135deg,#5b8fc4,#2f5e96)';
    if(/rojo|\bred\b|rot|rouge|rosso|czerwon|czerwie[nń]/.test(s))return 'linear-gradient(135deg,#d65548,#a82e22)';
    if(/verde|green|grün|vert|zielon/.test(s))return 'linear-gradient(135deg,#5aa86c,#2f7a42)';
    if(/amarillo|yellow|gelb|jaune|giallo|[zż][oó][lł][tc]/.test(s))return 'linear-gradient(135deg,#f2d24b,#d6a92a)';
    if(/marron|marrón|brown|braun|brun|br[aą]z/.test(s))return 'linear-gradient(135deg,#9c6b3f,#6e4626)';
    if(/gris|grey|gray|grau|szar|grafit|antracyt|graphite/.test(s))return 'linear-gradient(135deg,#9a9a9a,#6d6d6d)';
    if(/morado|purple|violet|fiolet|fiolg|purpur|lila/.test(s))return 'linear-gradient(135deg,#8a5fb0,#5e3a87)';
    if(/naranja|orange|pomarań|pomaran|arancio/.test(s))return 'linear-gradient(135deg,#e8923f,#c96a1e)';
    return '#e6e6e6';
  }
  function fsValues(fs){
    var out=[];
    fs.querySelectorAll('.variant-input').forEach(function(vi){
      var v=vi.getAttribute('data-value')||(vi.querySelector('input')||{}).value||'';
      if(v)out.push(v);
    });
    return out;
  }
  function isColorFs(fs){
    var vals=fsValues(fs);if(vals.length<2)return false;
    var hits=0;for(var i=0;i<vals.length;i++){if(bg(vals[i])!=='#e6e6e6')hits++;}
    return hits>=1 && hits>=Math.ceil(vals.length/2);
  }
  function updateLabel(fs){
    var wrap=fs.closest('.variant-wrapper')||fs.parentElement;
    var lbl=wrap?wrap.querySelector('.variant__label'):null;if(!lbl)return;
    if(!lbl.getAttribute('data-ml-base'))lbl.setAttribute('data-ml-base',lbl.textContent.trim());
    var sp=lbl.querySelector('.ml-sel-value');
    if(!sp){lbl.textContent=lbl.getAttribute('data-ml-base');sp=document.createElement('span');sp.className='ml-sel-value';lbl.appendChild(sp);}
    var ck=fs.querySelector('input:checked');var val=ck?(ck.value||ck.getAttribute('value')):'';
    sp.textContent=val?(' – '+val):'';
  }
  function applyOne(fs){
    if(!fs||fs.classList.contains('ml-swatches'))return;
    if(!isColorFs(fs))return;
    var inputs=fs.querySelectorAll('.variant-input');if(!inputs.length)return;
    for(var i=0;i<inputs.length;i++){
      var vi=inputs[i];var val=vi.getAttribute('data-value')||(vi.querySelector('input')||{}).value||'';
      var lbl=vi.querySelector('label');if(lbl){lbl.style.background=bg(val);lbl.setAttribute('title',val);}
    }
    fs.classList.add('ml-swatches');
    fs.addEventListener('change',function(){updateLabel(fs);});
    updateLabel(fs);
  }
  function run(root){try{(root||document).querySelectorAll('.variant-input-wrap').forEach(applyOne);}catch(e){}}
  if(document.readyState!=='loading')run(document);
  document.addEventListener('DOMContentLoaded',function(){run(document);});
  try{var obs=new MutationObserver(function(ms){ms.forEach(function(m){m.addedNodes.forEach(function(n){if(n.nodeType===1){if(n.matches&&n.matches('.variant-input-wrap'))applyOne(n);if(n.querySelectorAll)run(n);}});});});obs.observe(document.documentElement,{childList:true,subtree:true});}catch(e){}
})();

